'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isSameDay = {};

exports.__exports = isSameDay;
